/**
 * Customer-facing routes for header search (excludes admin, seller dashboards, and dynamic paths).
 * Keep in sync with src/router/index.js when adding public customer pages.
 */

export const CUSTOMER_NAV_CATEGORY_ORDER = [
  "Home",
  "Shop",
  "Resale",
  "Facilities",
  "Matches",
  "Tournaments",
  "Pathfinder",
  "The Able",
  "Account",
  "Support",
  "Company",
  "Legal",
];

const IPA = "/ipromiseafrica";

const CUSTOMER_NAV_SEARCH_ROUTES = [
  {
    path: "/",
    title: "Home",
    subtitle: "Landing page",
    keywords: ["start", "welcome", "ipromise", "ipromiseafrica", "toafrica"],
    category: "Home",
  },
  {
    path: `${IPA}/store`,
    title: "Ipastore",
    subtitle: "Shop sports gear and equipment",
    keywords: ["shop", "store", "gear", "buy", "products", "mall", "equipment", "toafrica"],
    category: "Shop",
  },
  {
    path: `${IPA}/kids`,
    title: "Kids sports store",
    subtitle: "Gear for early movement, play, and training",
    keywords: [
      "kids",
      "children",
      "youth",
      "junior",
      "motor skills",
      "play",
      "training",
      "kids store",
      "toafrica",
    ],
    category: "Shop",
  },
  {
    path: `${IPA}/store/wishlist`,
    title: "Wishlist",
    subtitle: "Saved items",
    keywords: ["saved", "favorites", "heart", "wish", "toafrica"],
    category: "Shop",
  },
  {
    path: `${IPA}/store/my-orders`,
    title: "My orders",
    subtitle: "Track your purchases and delivery status",
    keywords: ["orders", "tracking", "delivery", "purchases", "history", "toafrica"],
    category: "Shop",
  },
  {
    path: `${IPA}/cart`,
    title: "Shopping cart",
    subtitle: "Review items and checkout",
    keywords: ["checkout", "bag", "basket", "cart", "toafrica"],
    category: "Shop",
  },
  {
    path: `${IPA}/store/return-policy`,
    title: "Returns & refunds",
    subtitle: "Sales and refund policy",
    keywords: ["refund", "returns", "warranty", "toafrica"],
    category: "Legal",
  },
  {
    path: `${IPA}/resale`,
    title: "Resale marketplace",
    subtitle: "Second-hand sports gear",
    keywords: ["resale", "used", "marketplace", "third party", "preowned", "toafrica"],
    category: "Resale",
  },
  {
    path: `${IPA}/resale/buyer-product-view`,
    title: "Browse resale listings",
    subtitle: "Find items from sellers",
    keywords: ["browse", "listings", "buy used", "offers", "toafrica"],
    category: "Resale",
  },
  {
    path: `${IPA}/resale/saved-listings`,
    title: "Saved resale products",
    subtitle: "Bookmarks from the marketplace",
    keywords: ["bookmarks", "saved", "resale", "toafrica"],
    category: "Resale",
  },
  {
    path: `${IPA}/resale/seller-sign-up`,
    title: "Become a seller",
    subtitle: "Register on the resale marketplace",
    keywords: ["seller", "signup", "list items", "toafrica"],
    category: "Resale",
  },
  {
    path: `${IPA}/facility`,
    title: "Book a facility",
    subtitle: "Find pitches and venues",
    keywords: ["pitch", "field", "venue", "facility", "book", "hire", "toafrica"],
    category: "Facilities",
  },
  {
    path: `${IPA}/facility/available`,
    title: "Available facilities",
    subtitle: "See venues open for booking",
    keywords: ["available", "slots", "calendar", "venues", "toafrica"],
    category: "Facilities",
  },
  {
    path: `${IPA}/facility/installation`,
    title: "Facility installation",
    subtitle: "Sports facility build services",
    keywords: ["installation", "turf", "court", "construction", "toafrica"],
    category: "Facilities",
  },
  {
    path: `${IPA}/facility/owner-registration`,
    title: "List your facility",
    subtitle: "Register as a facility owner",
    keywords: ["owner", "register facility", "host", "list venue", "toafrica"],
    category: "Facilities",
  },
  {
    path: `${IPA}/facility/my-facility`,
    title: "My facility dashboard",
    subtitle: "Manage your facility",
    keywords: ["dashboard", "manage facility", "my venue", "toafrica"],
    category: "Facilities",
  },
  {
    path: `${IPA}/matchup`,
    title: "Match organizing",
    subtitle: "Hub for teams and matches",
    keywords: ["match", "soccer", "football", "team", "organizing", "matchup", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/league`,
    title: "Ipromise League",
    subtitle: "League play and standings",
    keywords: ["league", "competition", "tournament", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/football/register`,
    title: "Register football team",
    subtitle: "11-a-side squads, home ground, and fixtures",
    keywords: ["football", "soccer", "signup team", "new team", "create team", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/basketball/register`,
    title: "Register basketball team",
    subtitle: "5v5 or 3v3 crews, court preferences, and roster",
    keywords: ["basketball", "hoops", "signup team", "court", "5v5", "3v3", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/rugby/register`,
    title: "Register rugby team",
    subtitle: "Create a rugby club on Match Hub",
    keywords: ["rugby", "xv", "7s", "signup team", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/volleyball/register`,
    title: "Register volleyball team",
    subtitle: "Indoor or beach volleyball squads",
    keywords: ["volleyball", "beach", "signup team", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/tennis/register`,
    title: "Register tennis team",
    subtitle: "Tennis squads and match preferences",
    keywords: ["tennis", "racket", "signup team", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/invites`,
    title: "Team invites",
    subtitle: "Invitations you received",
    keywords: ["invitation", "join team", "invite", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/football/organize-match`,
    title: "Organize a match",
    subtitle: "Schedule a football game",
    keywords: ["schedule", "organize", "fixture", "discover teams", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/officials/register`,
    title: "Become a match official",
    subtitle: "Referees, umpires, and table officials",
    keywords: ["referee", "umpire", "official", "officiate", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/officials/dashboard`,
    title: "Match officials dashboard",
    subtitle: "Fixtures and officiating history",
    keywords: ["official dashboard", "referee dashboard", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/football/dashboard`,
    title: "Football team dashboard",
    subtitle: "Your team home",
    keywords: ["my team", "dashboard", "squad", "football", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/matchup/player/dashboard`,
    title: "Player dashboard",
    subtitle: "Your player profile",
    keywords: ["player", "member", "roster", "toafrica"],
    category: "Matches",
  },
  {
    path: `${IPA}/tournament`,
    title: "Tournaments",
    subtitle: "Create and manage football tournaments",
    keywords: ["tournament", "fixtures", "bracket", "competition", "toafrica"],
    category: "Tournaments",
  },
  {
    path: `${IPA}/tournament/fanbase`,
    title: "Tournament fanbase",
    subtitle: "Browse tournaments and prize pools",
    keywords: ["fanbase", "fans", "prize pool", "venues", "toafrica"],
    category: "Tournaments",
  },
  {
    path: `${IPA}/tournament/register`,
    title: "Tournament registration",
    subtitle: "Set up a new tournament",
    keywords: ["host tournament", "register tournament", "toafrica"],
    category: "Tournaments",
  },
  {
    path: `${IPA}/pathfinder`,
    title: "Pathfinder",
    subtitle: "Nurturing young African sports talent",
    keywords: [
      "pathfinder",
      "youth",
      "talent",
      "development",
      "coaching",
      "tracking",
      "mentorship",
      "kids",
      "children",
      "toafrica",
    ],
    category: "Pathfinder",
  },
  {
    path: `${IPA}/the-able`,
    title: "The Able",
    subtitle: "Kenyan paralympic sport & special schools",
    keywords: [
      "paralympic",
      "disability",
      "adaptive",
      "wheelchair",
      "special schools",
      "impaired",
      "the able",
      "inclusive sport",
      "toafrica",
    ],
    category: "The Able",
  },
  {
    path: `${IPA}/the-able/equipment`,
    title: "Paralympic equipment store",
    subtitle: "Adaptive sports equipment",
    keywords: ["equipment", "adaptive gear", "paralympic store", "toafrica"],
    category: "The Able",
  },
  {
    path: `${IPA}/sign-in`,
    title: "Sign in",
    subtitle: "Customer login",
    keywords: ["login", "account", "signin", "toafrica"],
    category: "Account",
  },
  {
    path: `${IPA}/account`,
    title: "Create account",
    subtitle: "Customer registration",
    keywords: ["signup", "register", "join", "toafrica"],
    category: "Account",
  },
  {
    path: `${IPA}/account/forgot-password`,
    title: "Forgot password",
    subtitle: "Reset your password",
    keywords: ["reset", "password", "recover", "toafrica"],
    category: "Account",
  },
  {
    path: `${IPA}/verify_email`,
    title: "Verify email",
    subtitle: "Complete email verification",
    keywords: ["verification", "email", "confirm", "toafrica"],
    category: "Account",
  },
  {
    path: `${IPA}/verify_otp`,
    title: "Verify OTP",
    subtitle: "Enter your one-time code",
    keywords: ["code", "otp", "sms", "toafrica"],
    category: "Account",
  },
  {
    path: `${IPA}/support`,
    title: "Support",
    subtitle: "Get help from our team",
    keywords: ["help", "contact", "assistance", "toafrica"],
    category: "Support",
  },
  {
    path: `${IPA}/support/acknowledgement`,
    title: "Support acknowledgement",
    subtitle: "Message received confirmation",
    keywords: ["thanks", "submitted", "confirmation", "toafrica"],
    category: "Support",
  },
  // Temporarily omitted: opening About Us times out. Restore this entry with the route.
  {
    path: `${IPA}/site-map`,
    title: "Site map",
    subtitle: "Browse all pages",
    keywords: ["sitemap", "navigation", "links", "toafrica"],
    category: "Company",
  },
  {
    path: `${IPA}/legal/internet-services/privacy-policy`,
    title: "Privacy policy",
    subtitle: "How we handle your data",
    keywords: ["privacy", "data", "cookies", "toafrica"],
    category: "Legal",
  },
  {
    path: `${IPA}/legal/internet-services/terms-of-use`,
    title: "Terms of use",
    subtitle: "Website terms and conditions",
    keywords: ["terms", "conditions", "legal", "toafrica"],
    category: "Legal",
  },
  {
    path: `${IPA}/legal/buyer-terms`,
    title: "Buyer terms",
    subtitle: "Terms for buyers",
    keywords: ["purchase", "buyer", "agreement", "toafrica"],
    category: "Legal",
  },
  {
    path: `${IPA}/legal/seller-terms`,
    title: "Seller terms",
    subtitle: "Terms for marketplace sellers",
    keywords: ["seller", "resale terms", "toafrica"],
    category: "Legal",
  },
  {
    path: `${IPA}/legal/community-guidelines`,
    title: "Community guidelines",
    subtitle: "Rules for our community",
    keywords: ["rules", "conduct", "safety", "toafrica"],
    category: "Legal",
  },
  {
    path: `${IPA}/legal/facility-ownership-terms`,
    title: "Facility ownership terms",
    subtitle: "Terms for facility owners",
    keywords: ["facility terms", "venue owner", "toafrica"],
    category: "Legal",
  },
];

function normalize(str) {
  return String(str || "")
    .toLowerCase()
    .trim()
    .replace(/\s+/g, " ");
}

function sortByCategoryOrder(items) {
  const order = CUSTOMER_NAV_CATEGORY_ORDER;
  return [...items].sort((a, b) => {
    const ia = order.indexOf(a.category);
    const ib = order.indexOf(b.category);
    const ra = ia === -1 ? 999 : ia;
    const rb = ib === -1 ? 999 : ib;
    if (ra !== rb) return ra - rb;
    return a.title.localeCompare(b.title);
  });
}

function haystackFor(item) {
  return normalize(
    [item.title, item.subtitle || "", item.category, item.path, ...(item.keywords || [])].join(" ")
  );
}

/**
 * @param {string} query
 * @param {number} [max]
 * @returns {Array<{ path: string, title: string, subtitle?: string, category: string, keywords?: string[] }>}
 */
export function searchCustomerNavRoutes(query, max = 80) {
  const q = normalize(query);
  if (!q) {
    return sortByCategoryOrder(CUSTOMER_NAV_SEARCH_ROUTES).slice(0, max);
  }

  const tokens = q.split(/\s+/).filter(Boolean);
  const scored = [];

  for (const item of CUSTOMER_NAV_SEARCH_ROUTES) {
    const hay = haystackFor(item);
    if (!tokens.every((t) => hay.includes(t))) continue;

    let score = 0;
    const titleLow = normalize(item.title);
    const pathLow = item.path.toLowerCase();

    for (const t of tokens) {
      if (titleLow.includes(t)) score += 12;
      if (pathLow.includes(t)) score += 4;
      if (normalize(item.subtitle || "").includes(t)) score += 6;
      for (const k of item.keywords || []) {
        if (normalize(k).includes(t)) score += 5;
      }
      if (normalize(item.category).includes(t)) score += 3;
    }

    scored.push({ item, score });
  }

  scored.sort((a, b) => b.score - a.score || a.item.title.localeCompare(b.item.title));
  return scored.slice(0, max).map((s) => s.item);
}
